import React from "react"
import styled from "styled-components"

import tokens from "../_tokens"

const StyledCaption = styled.p`
  margin-top: ${tokens.size.base}px;
  margin-bottom: ${1.5 * tokens.size.base}px;
  font-size: ${tokens.fontSize.text.s};
  color: ${tokens.color.text.muted};
`
function Caption(props) {
  return <StyledCaption {...props} />
}

export default Caption
